export const newscorepincodelist = [
    {
        "Pincode": 744301,
        "State": "ANDAMAN & NICOBAR ISLANDS",
        "District": "Nicobar",
        "City": "Nicobar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 744201,
        "State": "ANDAMAN & NICOBAR ISLANDS",
        "District": "North And Middle Andaman",
        "City": "North And Middle Andaman",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 744101,
        "State": "ANDAMAN & NICOBAR ISLANDS",
        "District": "South Andaman",
        "City": "South Andaman",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 515001,
        "State": "ANDHRA PRADESH",
        "District": "Anantapur",
        "City": "Anantapur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 515001,
        "State": "ANDHRA PRADESH",
        "District": "Anantapur",
        "City": "Guntakal",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 515001,
        "State": "ANDHRA PRADESH",
        "District": "Anantapur",
        "City": "Hindupur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 515001,
        "State": "ANDHRA PRADESH",
        "District": "Anantapur",
        "City": "Kadiri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 515001,
        "State": "ANDHRA PRADESH",
        "District": "Anantapur",
        "City": "Kothacheruvu",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 515001,
        "State": "ANDHRA PRADESH",
        "District": "Anantapur",
        "City": "Tadipatri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Bangarupalyam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Chandragiri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Chittoor",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Madanapalle",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Madanapalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Palamaneru",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Piler",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Punganur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Puttur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Renigunta",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Srikalahasti",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Tirupathi",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 517001,
        "State": "ANDHRA PRADESH",
        "District": "Chittoor",
        "City": "Venkatagirikota",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Amalapuram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Anaparthi",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Bhimadole",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Bhimavaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Chintalapudi",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Devarapalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "East Godavari",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Eluru",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Ganapavaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Hanuman Junction",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Jaggampeta",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Jangareddygudem",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Kaikalur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Kakinada",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Kovvur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Mandapet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Nagaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Narsapur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Palakol",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Payakaraopeta",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Penugonda",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Pitapuram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Rajahmundry",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Rajole",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Ramachandrapuram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Ravulapalem",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Razole",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Sakhinetipalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Tadepalligudem",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Tanuku",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Tuni",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Yanam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 533101,
        "State": "ANDHRA PRADESH",
        "District": "East Godavari",
        "City": "Yeleswaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Amaravathi",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Bapatla",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Chilakaluripet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Chilakaluripeta",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Chirala",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Dachepalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Guntur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Macherla",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Mangalagiri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Nagaralu",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Narasaraopet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Piduguralla",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Ponnur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Repalle",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Sattenapalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Tenali",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 522001,
        "State": "ANDHRA PRADESH",
        "District": "Guntur",
        "City": "Vinukonda",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Badwel",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Kadapa",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Porumamilla",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Proddutur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Pulivendula ",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Rajampet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 516001,
        "State": "ANDHRA PRADESH",
        "District": "Kadapa",
        "City": "Rayachoti",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Avaniggadda",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Challapalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Gannavaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Gudivada",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Ibrahimpatnam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Jaggaiahpet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Kankipadu",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Krishna",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Machilipatnam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Mangalagiri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Mylavaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Nandigama",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Nuzvidu",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Penuganchiprolu",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Repalle",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Tiruvuru",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Vijayawada",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Visannapet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 520001,
        "State": "ANDHRA PRADESH",
        "District": "Krishna",
        "City": "Vuyyur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Adoni",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Allagadda",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Alur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Atmakur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Banaganapalle",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Bethamcherla",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Dhone",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Kurnool",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Nandikotkur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Nandyal",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Pattikonda",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 518001,
        "State": "ANDHRA PRADESH",
        "District": "Kurnool",
        "City": "Yemmiganur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Buchireddypalem",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Gudur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Kavali",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Kota",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Kovvur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Naidupet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Nellore",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Sullurpet",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Vedayapalem",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Venkatagiri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 524001,
        "State": "ANDHRA PRADESH",
        "District": "Nellore",
        "City": "Vinjamuru",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Addanki",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Chimakurthy",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Darsi",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Kandukur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Kanigiri",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Markapuram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Martur",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Ongole",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Pamuru",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Prakasam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 523001,
        "State": "ANDHRA PRADESH",
        "District": "Prakasam",
        "City": "Singarayakonda",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 532001,
        "State": "ANDHRA PRADESH",
        "District": "Srikakulam",
        "City": "Srikakulam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Anakapalli",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Bobbili",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Narsipatnam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Palasa",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Parvathipuram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Rajam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Visakhapatnam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 530001,
        "State": "ANDHRA PRADESH",
        "District": "Visakhapatnam",
        "City": "Yalamanchali",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 535001,
        "State": "ANDHRA PRADESH",
        "District": "Vizianagarm",
        "City": "Vizianagaram",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 535001,
        "State": "ANDHRA PRADESH",
        "District": "Vizianagarm",
        "City": "Vizianagarm",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 534001,
        "State": "ANDHRA PRADESH",
        "District": "West Godavari",
        "City": "Eluru",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 534001,
        "State": "ANDHRA PRADESH",
        "District": "West Godavari",
        "City": "Palakol",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 534001,
        "State": "ANDHRA PRADESH",
        "District": "West Godavari",
        "City": "West Godavari",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 792055,
        "State": "ARUNACHAL PRADESH",
        "District": "Changlang",
        "City": "Changlang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 792101,
        "State": "ARUNACHAL PRADESH",
        "District": "Dibang Valley",
        "City": "Dibang Valley",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 790102,
        "State": "ARUNACHAL PRADESH",
        "District": "East Kameng",
        "City": "East Kameng",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 791102,
        "State": "ARUNACHAL PRADESH",
        "District": "East Siang",
        "City": "East Siang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 791118,
        "State": "ARUNACHAL PRADESH",
        "District": "Kurung Kumey",
        "City": "Kurung Kumey",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 792001,
        "State": "ARUNACHAL PRADESH",
        "District": "Lohit",
        "City": "Lohit",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 792110,
        "State": "ARUNACHAL PRADESH",
        "District": "Lower Dibang Valley",
        "City": "Lower Dibang Valley",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 791113,
        "State": "ARUNACHAL PRADESH",
        "District": "Lower Subansiri",
        "City": "Lower Subansiri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 790001,
        "State": "ARUNACHAL PRADESH",
        "District": "Papum Pare",
        "City": "Papum Pare",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 790104,
        "State": "ARUNACHAL PRADESH",
        "District": "Tawang",
        "City": "Tawang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 792129,
        "State": "ARUNACHAL PRADESH",
        "District": "Tirap",
        "City": "Tirap",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 791002,
        "State": "ARUNACHAL PRADESH",
        "District": "Upper Siang",
        "City": "Upper Siang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 791122,
        "State": "ARUNACHAL PRADESH",
        "District": "Upper Subansiri",
        "City": "Upper Subansiri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 790001,
        "State": "ARUNACHAL PRADESH",
        "District": "West Kameng",
        "City": "West Kameng",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 791001,
        "State": "ARUNACHAL PRADESH",
        "District": "West Siang",
        "City": "West Siang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 781301,
        "State": "ASSAM",
        "District": "Barpeta",
        "City": "Barpeta",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 783134,
        "State": "ASSAM",
        "District": "Bongaigaon",
        "City": "Bongaigaon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 788001,
        "State": "ASSAM",
        "District": "Cachar",
        "City": "Cachar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 784113,
        "State": "ASSAM",
        "District": "Darrang",
        "City": "Darrang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 787026,
        "State": "ASSAM",
        "District": "Dhemaji",
        "City": "Dhemaji",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 783127,
        "State": "ASSAM",
        "District": "Dhubri",
        "City": "Dhubri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 785675,
        "State": "ASSAM",
        "District": "Dibrugarh",
        "City": "Dibrugarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 783101,
        "State": "ASSAM",
        "District": "Goalpara",
        "City": "Goalpara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 785104,
        "State": "ASSAM",
        "District": "Golaghat",
        "City": "Golaghat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 788117,
        "State": "ASSAM",
        "District": "Hailakandi",
        "City": "Hailakandi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 785001,
        "State": "ASSAM",
        "District": "Jorhat",
        "City": "Jorhat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 781001,
        "State": "ASSAM",
        "District": "Kamrup",
        "City": "Kamrup",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 782139,
        "State": "ASSAM",
        "District": "Karbi Anglong",
        "City": "Karbi Anglong",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 788006,
        "State": "ASSAM",
        "District": "Karimganj",
        "City": "Karimganj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 783127,
        "State": "ASSAM",
        "District": "Kokrajhar",
        "City": "Kokrajhar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 784160,
        "State": "ASSAM",
        "District": "Lakhimpur",
        "City": "Lakhimpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 782001,
        "State": "ASSAM",
        "District": "Marigaon",
        "City": "Marigaon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 782001,
        "State": "ASSAM",
        "District": "Nagaon",
        "City": "Nagaon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 781126,
        "State": "ASSAM",
        "District": "Nalbari",
        "City": "Nalbari",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 788108,
        "State": "ASSAM",
        "District": "North Cachar Hills",
        "City": "North Cachar Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 785006,
        "State": "ASSAM",
        "District": "Sibsagar",
        "City": "Sibsagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 784001,
        "State": "ASSAM",
        "District": "Sonitpur",
        "City": "Sonitpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 786125,
        "State": "ASSAM",
        "District": "Tinsukia",
        "City": "Tinsukia",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 854102,
        "State": "BIHAR",
        "District": "Araria",
        "City": "Araria",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 804401,
        "State": "BIHAR",
        "District": "Arwal",
        "City": "Arwal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 824101,
        "State": "BIHAR",
        "District": "Aurangabad(BH)",
        "City": "Aurangabad(BH)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811308,
        "State": "BIHAR",
        "District": "Banka",
        "City": "Banka",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811106,
        "State": "BIHAR",
        "District": "Begusarai",
        "City": "Begusarai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811211,
        "State": "BIHAR",
        "District": "Bhagalpur",
        "City": "Bhagalpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 802152,
        "State": "BIHAR",
        "District": "Bhojpur",
        "City": "Bhojpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 802101,
        "State": "BIHAR",
        "District": "Buxar",
        "City": "Buxar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 846001,
        "State": "BIHAR",
        "District": "Darbhanga",
        "City": "Darbhanga",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 845301,
        "State": "BIHAR",
        "District": "East Champaran",
        "City": "East Champaran",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 804401,
        "State": "BIHAR",
        "District": "Gaya",
        "City": "Gaya",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 841405,
        "State": "BIHAR",
        "District": "Gopalganj",
        "City": "Gopalganj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811301,
        "State": "BIHAR",
        "District": "Jamui",
        "City": "Jamui",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 804405,
        "State": "BIHAR",
        "District": "Jehanabad",
        "City": "Jehanabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 802132,
        "State": "BIHAR",
        "District": "Kaimur (Bhabua)",
        "City": "Kaimur (Bhabua)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 853204,
        "State": "BIHAR",
        "District": "Katihar",
        "City": "Katihar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811202,
        "State": "BIHAR",
        "District": "Khagaria",
        "City": "Khagaria",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 855101,
        "State": "BIHAR",
        "District": "Kishanganj",
        "City": "Kishanganj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811106,
        "State": "BIHAR",
        "District": "Lakhisarai",
        "City": "Lakhisarai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 813204,
        "State": "BIHAR",
        "District": "Madhepura",
        "City": "Madhepura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 847102,
        "State": "BIHAR",
        "District": "Madhubani",
        "City": "Madhubani",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811201,
        "State": "BIHAR",
        "District": "Munger",
        "City": "Munger",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 842001,
        "State": "BIHAR",
        "District": "Muzaffarpur",
        "City": "Muzaffarpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 801301,
        "State": "BIHAR",
        "District": "Nalanda",
        "City": "Nalanda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 803109,
        "State": "BIHAR",
        "District": "Nawada",
        "City": "Nawada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 800001,
        "State": "BIHAR",
        "District": "Patna",
        "City": "Patna",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 853204,
        "State": "BIHAR",
        "District": "Purnia",
        "City": "Purnia",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 802211,
        "State": "BIHAR",
        "District": "Rohtas",
        "City": "Rohtas",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 852106,
        "State": "BIHAR",
        "District": "Saharsa",
        "City": "Saharsa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 844501,
        "State": "BIHAR",
        "District": "Samastipur",
        "City": "Samastipur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 841101,
        "State": "BIHAR",
        "District": "Saran",
        "City": "Saran",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 811101,
        "State": "BIHAR",
        "District": "Sheikhpura",
        "City": "Sheikhpura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 843313,
        "State": "BIHAR",
        "District": "Sheohar",
        "City": "Sheohar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 843301,
        "State": "BIHAR",
        "District": "Sitamarhi",
        "City": "Sitamarhi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 841203,
        "State": "BIHAR",
        "District": "Siwan",
        "City": "Siwan",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 847408,
        "State": "BIHAR",
        "District": "Supaul",
        "City": "Supaul",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 843102,
        "State": "BIHAR",
        "District": "Vaishali",
        "City": "Vaishali",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 845101,
        "State": "BIHAR",
        "District": "West Champaran",
        "City": "West Champaran",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 140119,
        "State": "CHANDIGARH",
        "District": "Chandigarh",
        "City": "Chandigarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 494001,
        "State": "CHATTISGARH",
        "District": "Bastar",
        "City": "Bastar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 494444,
        "State": "CHATTISGARH",
        "District": "Bijapur(CGH)",
        "City": "Bijapur(CGH)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 495001,
        "State": "CHATTISGARH",
        "District": "Bilaspur(CGH)",
        "City": "Bilaspur(CGH)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 494111,
        "State": "CHATTISGARH",
        "District": "Dantewada",
        "City": "Dantewada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 493662,
        "State": "CHATTISGARH",
        "District": "Dhamtari",
        "City": "Dhamtari",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 490001,
        "State": "CHATTISGARH",
        "District": "Durg",
        "City": "Durg",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 493887,
        "State": "CHATTISGARH",
        "District": "Gariaband",
        "City": "Gariaband",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 495552,
        "State": "CHATTISGARH",
        "District": "Janjgir-champa",
        "City": "Janjgir-champa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 496118,
        "State": "CHATTISGARH",
        "District": "Jashpur",
        "City": "Jashpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 494333,
        "State": "CHATTISGARH",
        "District": "Kanker",
        "City": "Kanker",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 491336,
        "State": "CHATTISGARH",
        "District": "Kawardha",
        "City": "Kawardha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 495118,
        "State": "CHATTISGARH",
        "District": "Korba",
        "City": "Korba",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 497331,
        "State": "CHATTISGARH",
        "District": "Koriya",
        "City": "Koriya",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 492112,
        "State": "CHATTISGARH",
        "District": "Mahasamund",
        "City": "Mahasamund",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 494661,
        "State": "CHATTISGARH",
        "District": "Narayanpur",
        "City": "Narayanpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 496001,
        "State": "CHATTISGARH",
        "District": "Raigarh",
        "City": "Raigarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 492001,
        "State": "CHATTISGARH",
        "District": "Raipur",
        "City": "Raipur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 491229,
        "State": "CHATTISGARH",
        "District": "Rajnandgaon",
        "City": "Rajnandgaon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 497001,
        "State": "CHATTISGARH",
        "District": "Surguja",
        "City": "Surguja",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 396193,
        "State": "DADRA & NAGAR HAVELI",
        "District": "Dadra & Nagar Haveli",
        "City": "Dadra & Nagar Haveli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 396210,
        "State": "DAMAN & DIU",
        "District": "Daman",
        "City": "Daman",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 362520,
        "State": "DAMAN & DIU",
        "District": "Diu",
        "City": "Diu",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 110001,
        "State": "DELHI",
        "District": "Delhi",
        "City": "Delhi",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 110001,
        "State": "DELHI",
        "District": "Delhi",
        "City": "Gurugram",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 403001,
        "State": "GOA",
        "District": "North Goa",
        "City": "North Goa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 403105,
        "State": "GOA",
        "District": "South Goa",
        "City": "South Goa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 380001,
        "State": "GUJARAT",
        "District": "Ahmedabad",
        "City": "Ahmedabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 362730,
        "State": "GUJARAT",
        "District": "Amreli",
        "City": "Amreli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 387210,
        "State": "GUJARAT",
        "District": "Anand",
        "City": "Anand",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 385001,
        "State": "GUJARAT",
        "District": "Banaskantha",
        "City": "Banaskantha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 391810,
        "State": "GUJARAT",
        "District": "Bharuch",
        "City": "Bharuch",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 364001,
        "State": "GUJARAT",
        "District": "Bhavnagar",
        "City": "Bhavnagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 389110,
        "State": "GUJARAT",
        "District": "Dahod",
        "City": "Dahod",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 380060,
        "State": "GUJARAT",
        "District": "Gandhi Nagar",
        "City": "Gandhi Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 360110,
        "State": "GUJARAT",
        "District": "Jamnagar",
        "City": "Jamnagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 360490,
        "State": "GUJARAT",
        "District": "Junagadh",
        "City": "Junagadh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 370001,
        "State": "GUJARAT",
        "District": "Kachchh",
        "City": "Kachchh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 387001,
        "State": "GUJARAT",
        "District": "Kheda",
        "City": "Kheda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 382115,
        "State": "GUJARAT",
        "District": "Mahesana",
        "City": "Mahesana",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 391110,
        "State": "GUJARAT",
        "District": "Narmada",
        "City": "Narmada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 394730,
        "State": "GUJARAT",
        "District": "Navsari",
        "City": "Navsari",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 388270,
        "State": "GUJARAT",
        "District": "Panch Mahals",
        "City": "Panch Mahals",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 384110,
        "State": "GUJARAT",
        "District": "Patan",
        "City": "Patan",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 360490,
        "State": "GUJARAT",
        "District": "Porbandar",
        "City": "Porbandar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 360001,
        "State": "GUJARAT",
        "District": "Rajkot",
        "City": "Rajkot",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 383001,
        "State": "GUJARAT",
        "District": "Sabarkantha",
        "City": "Sabarkantha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 392150,
        "State": "GUJARAT",
        "District": "Surat",
        "City": "Surat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 360055,
        "State": "GUJARAT",
        "District": "Surendra Nagar",
        "City": "Surendra Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 394365,
        "State": "GUJARAT",
        "District": "Tapi",
        "City": "Tapi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 394710,
        "State": "GUJARAT",
        "District": "The Dangs",
        "City": "The Dangs",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 388710,
        "State": "GUJARAT",
        "District": "Vadodara",
        "City": "Vadodara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 396001,
        "State": "GUJARAT",
        "District": "Valsad",
        "City": "Valsad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 133001,
        "State": "HARYANA",
        "District": "Ambala",
        "City": "Ambala",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 127021,
        "State": "HARYANA",
        "District": "Bhiwani",
        "City": "Bhiwani",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 121001,
        "State": "HARYANA",
        "District": "Faridabad",
        "City": "Faridabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 125048,
        "State": "HARYANA",
        "District": "Fatehabad",
        "City": "Fatehabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 122001,
        "State": "HARYANA",
        "District": "Gurgaon",
        "City": "Gurgaon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 125001,
        "State": "HARYANA",
        "District": "Hisar",
        "City": "Hisar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 124102,
        "State": "HARYANA",
        "District": "Jhajjar",
        "City": "Jhajjar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 126101,
        "State": "HARYANA",
        "District": "Jind",
        "City": "Jind",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 136020,
        "State": "HARYANA",
        "District": "Kaithal",
        "City": "Kaithal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 132001,
        "State": "HARYANA",
        "District": "Karnal",
        "City": "Karnal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 136030,
        "State": "HARYANA",
        "District": "Kurukshetra",
        "City": "Kurukshetra",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 123001,
        "State": "HARYANA",
        "District": "Mahendragarh",
        "City": "Mahendragarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 121102,
        "State": "HARYANA",
        "District": "Palwal",
        "City": "Palwal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 133301,
        "State": "HARYANA",
        "District": "Panchkula",
        "City": "Panchkula",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 132101,
        "State": "HARYANA",
        "District": "Panipat",
        "City": "Panipat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 123021,
        "State": "HARYANA",
        "District": "Rewari",
        "City": "Rewari",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 124001,
        "State": "HARYANA",
        "District": "Rohtak",
        "City": "Meham",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 124001,
        "State": "HARYANA",
        "District": "Rohtak",
        "City": "Rohtak",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 125054,
        "State": "HARYANA",
        "District": "Sirsa",
        "City": "Sirsa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 131001,
        "State": "HARYANA",
        "District": "Sonipat",
        "City": "Sonipat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 133103,
        "State": "HARYANA",
        "District": "Yamuna Nagar",
        "City": "Yamuna Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 174001,
        "State": "HIMACHAL PRADESH",
        "District": "Bilaspur (HP)",
        "City": "Bilaspur (HP)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 176207,
        "State": "HIMACHAL PRADESH",
        "District": "Chamba",
        "City": "Chamba",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 174304,
        "State": "HIMACHAL PRADESH",
        "District": "Hamirpur(HP)",
        "City": "Hamirpur(HP)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 175013,
        "State": "HIMACHAL PRADESH",
        "District": "Kangra",
        "City": "Kangra",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 172030,
        "State": "HIMACHAL PRADESH",
        "District": "Kinnaur",
        "City": "Kinnaur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 172001,
        "State": "HIMACHAL PRADESH",
        "District": "Kullu",
        "City": "Kullu",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 172113,
        "State": "HIMACHAL PRADESH",
        "District": "Lahul & Spiti",
        "City": "Lahul & Spiti",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 175001,
        "State": "HIMACHAL PRADESH",
        "District": "Mandi",
        "City": "Mandi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 171001,
        "State": "HIMACHAL PRADESH",
        "District": "Shimla",
        "City": "Shimla",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 171226,
        "State": "HIMACHAL PRADESH",
        "District": "Sirmaur",
        "City": "Sirmaur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 171102,
        "State": "HIMACHAL PRADESH",
        "District": "Solan",
        "City": "Solan",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 174301,
        "State": "HIMACHAL PRADESH",
        "District": "Una",
        "City": "Una",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 191103,
        "State": "JAMMU & KASHMIR",
        "District": "Ananthnag",
        "City": "Ananthnag",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 193503,
        "State": "JAMMU & KASHMIR",
        "District": "Bandipur",
        "City": "Bandipur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 192125,
        "State": "JAMMU & KASHMIR",
        "District": "Baramulla",
        "City": "Baramulla",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 190005,
        "State": "JAMMU & KASHMIR",
        "District": "Budgam",
        "City": "Budgam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 182124,
        "State": "JAMMU & KASHMIR",
        "District": "Doda",
        "City": "Doda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 180001,
        "State": "JAMMU & KASHMIR",
        "District": "Jammu",
        "City": "Jammu",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 194102,
        "State": "JAMMU & KASHMIR",
        "District": "Kargil",
        "City": "Kargil",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 184101,
        "State": "JAMMU & KASHMIR",
        "District": "Kathua",
        "City": "Kathua",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 192233,
        "State": "JAMMU & KASHMIR",
        "District": "Kulgam",
        "City": "Kulgam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 193221,
        "State": "JAMMU & KASHMIR",
        "District": "Kupwara",
        "City": "Kupwara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 194101,
        "State": "JAMMU & KASHMIR",
        "District": "Leh",
        "City": "Leh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 184121,
        "State": "JAMMU & KASHMIR",
        "District": "Poonch",
        "City": "Poonch",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 191112,
        "State": "JAMMU & KASHMIR",
        "District": "Pulwama",
        "City": "Pulwama",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 185121,
        "State": "JAMMU & KASHMIR",
        "District": "Rajauri",
        "City": "Rajauri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 182311,
        "State": "JAMMU & KASHMIR",
        "District": "Reasi",
        "City": "Reasi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 192305,
        "State": "JAMMU & KASHMIR",
        "District": "Shopian",
        "City": "Shopian",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 190001,
        "State": "JAMMU & KASHMIR",
        "District": "Srinagar",
        "City": "Srinagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 182101,
        "State": "JAMMU & KASHMIR",
        "District": "Udhampur",
        "City": "Udhampur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 814155,
        "State": "JHARKHAND",
        "District": "Bokaro",
        "City": "Bokaro",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 825103,
        "State": "JHARKHAND",
        "District": "Chatra",
        "City": "Chatra",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 814112,
        "State": "JHARKHAND",
        "District": "Deoghar",
        "City": "Deoghar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 826001,
        "State": "JHARKHAND",
        "District": "Dhanbad",
        "City": "Dhanbad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 814101,
        "State": "JHARKHAND",
        "District": "Dumka",
        "City": "Dumka",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 831001,
        "State": "JHARKHAND",
        "District": "East Singhbhum",
        "City": "East Singhbhum",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 822112,
        "State": "JHARKHAND",
        "District": "Garhwa",
        "City": "Garhwa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 815301,
        "State": "JHARKHAND",
        "District": "Giridh",
        "City": "Giridh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 813208,
        "State": "JHARKHAND",
        "District": "Godda",
        "City": "Godda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 835203,
        "State": "JHARKHAND",
        "District": "Gumla",
        "City": "Gumla",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 825301,
        "State": "JHARKHAND",
        "District": "Hazaribag",
        "City": "Hazaribag",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 814166,
        "State": "JHARKHAND",
        "District": "Jamtara",
        "City": "Jamtara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 835235,
        "State": "JHARKHAND",
        "District": "Khunti",
        "City": "Khunti",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 825109,
        "State": "JHARKHAND",
        "District": "Koderma",
        "City": "Koderma",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 822111,
        "State": "JHARKHAND",
        "District": "Latehar",
        "City": "Latehar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 834004,
        "State": "JHARKHAND",
        "District": "Lohardaga",
        "City": "Lohardaga",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 814111,
        "State": "JHARKHAND",
        "District": "Pakur",
        "City": "Pakur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 822101,
        "State": "JHARKHAND",
        "District": "Palamau",
        "City": "Palamau",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 825101,
        "State": "JHARKHAND",
        "District": "Ramgarh",
        "City": "Ramgarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 829205,
        "State": "JHARKHAND",
        "District": "Ranchi",
        "City": "Ranchi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 813208,
        "State": "JHARKHAND",
        "District": "Sahibganj",
        "City": "Sahibganj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 831002,
        "State": "JHARKHAND",
        "District": "Seraikela-kharsawan",
        "City": "Seraikela-kharsawan",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 835201,
        "State": "JHARKHAND",
        "District": "Simdega",
        "City": "Simdega",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 831013,
        "State": "JHARKHAND",
        "District": "West Singhbhum",
        "City": "West Singhbhum",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 586113,
        "State": "KARNATAKA",
        "District": "Bagalkot",
        "City": "Bagalkot",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 590001,
        "State": "KARNATAKA",
        "District": "Belgaum",
        "City": "Belgaum",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 583101,
        "State": "KARNATAKA",
        "District": "Bellary",
        "City": "Ballari",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 583101,
        "State": "KARNATAKA",
        "District": "Bellary",
        "City": "Bellary",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 583101,
        "State": "KARNATAKA",
        "District": "Bellary",
        "City": "Hospet",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 560001,
        "State": "KARNATAKA",
        "District": "Bengaluru",
        "City": "Bengaluru",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 583101,
        "State": "KARNATAKA",
        "District": "Bengaluru",
        "City": "Davanagere",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 583101,
        "State": "KARNATAKA",
        "District": "Bengaluru",
        "City": "Mangalore",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 583101,
        "State": "KARNATAKA",
        "District": "Bengaluru",
        "City": "Tumkur",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 560060,
        "State": "KARNATAKA",
        "District": "Bengaluru Rural",
        "City": "Bengaluru Rural",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 585226,
        "State": "KARNATAKA",
        "District": "Bidar",
        "City": "Bidar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 586101,
        "State": "KARNATAKA",
        "District": "Bijapur(KAR)",
        "City": "Bijapur(KAR)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 571109,
        "State": "KARNATAKA",
        "District": "Chamrajnagar",
        "City": "Chamrajnagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 577101,
        "State": "KARNATAKA",
        "District": "Chickmagalur",
        "City": "Chickmagalur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 561206,
        "State": "KARNATAKA",
        "District": "Chikkaballapur",
        "City": "Chikkaballapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 577501,
        "State": "KARNATAKA",
        "District": "Chitradurga",
        "City": "Chitradurga",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 574107,
        "State": "KARNATAKA",
        "District": "Dakshina Kannada",
        "City": "Dakshina Kannada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 577001,
        "State": "KARNATAKA",
        "District": "Davangere",
        "City": "Davangere",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 580001,
        "State": "KARNATAKA",
        "District": "Dharwad",
        "City": "Dharwad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 580001,
        "State": "KARNATAKA",
        "District": "Dharwad",
        "City": "Hubli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 582101,
        "State": "KARNATAKA",
        "District": "Gadag",
        "City": "Gadag",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 585101,
        "State": "KARNATAKA",
        "District": "Gulbarga",
        "City": "Gulbarga",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 573101,
        "State": "KARNATAKA",
        "District": "Hassan",
        "City": "Hassan",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 581101,
        "State": "KARNATAKA",
        "District": "Haveri",
        "City": "Haveri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 571201,
        "State": "KARNATAKA",
        "District": "Kodagu",
        "City": "Kodagu",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 561206,
        "State": "KARNATAKA",
        "District": "Kolar",
        "City": "Kolar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 583226,
        "State": "KARNATAKA",
        "District": "Koppal",
        "City": "Gangavathi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 583226,
        "State": "KARNATAKA",
        "District": "Koppal",
        "City": "Koppal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 571401,
        "State": "KARNATAKA",
        "District": "Mandya",
        "City": "Mandya",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 570001,
        "State": "KARNATAKA",
        "District": "Mysore",
        "City": "Mysore",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 584101,
        "State": "KARNATAKA",
        "District": "Raichur",
        "City": "Raichur",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 584101,
        "State": "KARNATAKA",
        "District": "Raichur",
        "City": "Sindhanur",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 561201,
        "State": "KARNATAKA",
        "District": "Ramanagar",
        "City": "Ramanagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 577115,
        "State": "KARNATAKA",
        "District": "Shimoga",
        "City": "Shimoga",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 561202,
        "State": "KARNATAKA",
        "District": "Tumkur",
        "City": "Tumkur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 574101,
        "State": "KARNATAKA",
        "District": "Udupi",
        "City": "Udupi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 581121,
        "State": "KARNATAKA",
        "District": "Uttara Kannada",
        "City": "Uttara Kannada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 585201,
        "State": "KARNATAKA",
        "District": "Yadgir",
        "City": "Yadgir",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 686102,
        "State": "KERALA",
        "District": "Alappuzha",
        "City": "Alappuzha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 680667,
        "State": "KERALA",
        "District": "Ernakulam",
        "City": "Ernakulam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 685501,
        "State": "KERALA",
        "District": "Idukki",
        "City": "Idukki",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 670001,
        "State": "KERALA",
        "District": "Kannur",
        "City": "Kannur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 670511,
        "State": "KERALA",
        "District": "Kasargod",
        "City": "Kasargod",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 682001,
        "State": "KERALA",
        "District": "Kochi",
        "City": "Kochi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 689695,
        "State": "KERALA",
        "District": "Kollam",
        "City": "Kollam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 686001,
        "State": "KERALA",
        "District": "Kottayam",
        "City": "Kottayam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 673001,
        "State": "KERALA",
        "District": "Kozhikode",
        "City": "Kozhikode",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 673314,
        "State": "KERALA",
        "District": "Malappuram",
        "City": "Malappuram",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 678001,
        "State": "KERALA",
        "District": "Palakkad",
        "City": "Palakkad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 685533,
        "State": "KERALA",
        "District": "Pathanamthitta",
        "City": "Pathanamthitta",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 695001,
        "State": "KERALA",
        "District": "Thiruvananthapuram",
        "City": "Thiruvananthapuram",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 679105,
        "State": "KERALA",
        "District": "Thrissur",
        "City": "Thrissur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 670644,
        "State": "KERALA",
        "District": "Wayanad",
        "City": "Wayanad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 682551,
        "State": "LAKSHADWEEP",
        "District": "Lakshadweep",
        "City": "Lakshadweep",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 457885,
        "State": "MADHYA PRADESH",
        "District": "Alirajpur",
        "City": "Alirajpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 484001,
        "State": "MADHYA PRADESH",
        "District": "Anuppur",
        "City": "Anuppur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 473330,
        "State": "MADHYA PRADESH",
        "District": "Ashok Nagar",
        "City": "Ashok Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 481001,
        "State": "MADHYA PRADESH",
        "District": "Balaghat",
        "City": "Balaghat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 451442,
        "State": "MADHYA PRADESH",
        "District": "Barwani",
        "City": "Barwani",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 460001,
        "State": "MADHYA PRADESH",
        "District": "Betul",
        "City": "Betul",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 475110,
        "State": "MADHYA PRADESH",
        "District": "Bhind",
        "City": "Bhind",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 462001,
        "State": "MADHYA PRADESH",
        "District": "Bhopal",
        "City": "Bhopal",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 450001,
        "State": "MADHYA PRADESH",
        "District": "Burhanpur",
        "City": "Burhanpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 471001,
        "State": "MADHYA PRADESH",
        "District": "Chhatarpur",
        "City": "Chhatarpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 460663,
        "State": "MADHYA PRADESH",
        "District": "Chhindwara",
        "City": "Chhindwara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 470661,
        "State": "MADHYA PRADESH",
        "District": "Damoh",
        "City": "Damoh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 475335,
        "State": "MADHYA PRADESH",
        "District": "Datia",
        "City": "Datia",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 455001,
        "State": "MADHYA PRADESH",
        "District": "Dewas",
        "City": "Dewas",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 454001,
        "State": "MADHYA PRADESH",
        "District": "Dhar",
        "City": "Dhar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 481672,
        "State": "MADHYA PRADESH",
        "District": "Dindori",
        "City": "Dindori",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 450001,
        "State": "MADHYA PRADESH",
        "District": "East Nimar",
        "City": "East Nimar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 473001,
        "State": "MADHYA PRADESH",
        "District": "Guna",
        "City": "Guna",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 474001,
        "State": "MADHYA PRADESH",
        "District": "Gwalior",
        "City": "Gwalior",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 461111,
        "State": "MADHYA PRADESH",
        "District": "Harda",
        "City": "Harda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 461001,
        "State": "MADHYA PRADESH",
        "District": "Hoshangabad",
        "City": "Hoshangabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 452001,
        "State": "MADHYA PRADESH",
        "District": "Indore",
        "City": "Indore",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 482001,
        "State": "MADHYA PRADESH",
        "District": "Jabalpur",
        "City": "Jabalpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 457550,
        "State": "MADHYA PRADESH",
        "District": "Jhabua",
        "City": "Jhabua",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 483220,
        "State": "MADHYA PRADESH",
        "District": "Katni",
        "City": "Katni",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 450112,
        "State": "MADHYA PRADESH",
        "District": "Khandwa",
        "City": "Khandwa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 451332,
        "State": "MADHYA PRADESH",
        "District": "Khargone",
        "City": "Khargone",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 481661,
        "State": "MADHYA PRADESH",
        "District": "Mandla",
        "City": "Mandla",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 458001,
        "State": "MADHYA PRADESH",
        "District": "Mandsaur",
        "City": "Mandsaur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 476001,
        "State": "MADHYA PRADESH",
        "District": "Morena",
        "City": "Morena",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 461771,
        "State": "MADHYA PRADESH",
        "District": "Narsinghpur",
        "City": "Narsinghpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 458110,
        "State": "MADHYA PRADESH",
        "District": "Neemuch",
        "City": "Neemuch",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 488001,
        "State": "MADHYA PRADESH",
        "District": "Panna",
        "City": "Panna",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 464551,
        "State": "MADHYA PRADESH",
        "District": "Raisen",
        "City": "Raisen",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 465661,
        "State": "MADHYA PRADESH",
        "District": "Rajgarh",
        "City": "Rajgarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 457001,
        "State": "MADHYA PRADESH",
        "District": "Ratlam",
        "City": "Ratlam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 485331,
        "State": "MADHYA PRADESH",
        "District": "Rewa",
        "City": "Rewa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 464240,
        "State": "MADHYA PRADESH",
        "District": "Sagar",
        "City": "Sagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 485001,
        "State": "MADHYA PRADESH",
        "District": "Satna",
        "City": "Satna",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 465693,
        "State": "MADHYA PRADESH",
        "District": "Sehore",
        "City": "Sehore",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 480661,
        "State": "MADHYA PRADESH",
        "District": "Seoni",
        "City": "Seoni",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 484001,
        "State": "MADHYA PRADESH",
        "District": "Shahdol",
        "City": "Shahdol",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 465001,
        "State": "MADHYA PRADESH",
        "District": "Shajapur",
        "City": "Shajapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 476332,
        "State": "MADHYA PRADESH",
        "District": "Sheopur",
        "City": "Sheopur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 473551,
        "State": "MADHYA PRADESH",
        "District": "Shivpuri",
        "City": "Shivpuri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 484771,
        "State": "MADHYA PRADESH",
        "District": "Sidhi",
        "City": "Sidhi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 486885,
        "State": "MADHYA PRADESH",
        "District": "Singrauli",
        "City": "Singrauli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 472001,
        "State": "MADHYA PRADESH",
        "District": "Tikamgarh",
        "City": "Tikamgarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 456001,
        "State": "MADHYA PRADESH",
        "District": "Ujjain",
        "City": "Ujjain",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 484001,
        "State": "MADHYA PRADESH",
        "District": "Umaria",
        "City": "Umaria",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 464001,
        "State": "MADHYA PRADESH",
        "District": "Vidisha",
        "City": "Vidisha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 450551,
        "State": "MADHYA PRADESH",
        "District": "West Nimar",
        "City": "West Nimar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 413201,
        "State": "MAHARASHTRA",
        "District": "Ahmed Nagar",
        "City": "Ahmed Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 444001,
        "State": "MAHARASHTRA",
        "District": "Akola",
        "City": "Akola",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 442302,
        "State": "MAHARASHTRA",
        "District": "Amravati",
        "City": "Amravati",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 423701,
        "State": "MAHARASHTRA",
        "District": "Aurangabad",
        "City": "Aurangabad",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 413207,
        "State": "MAHARASHTRA",
        "District": "Beed",
        "City": "Beed",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 441802,
        "State": "MAHARASHTRA",
        "District": "Bhandara",
        "City": "Bhandara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 443001,
        "State": "MAHARASHTRA",
        "District": "Buldhana",
        "City": "Buldhana",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 441205,
        "State": "MAHARASHTRA",
        "District": "Chandrapur",
        "City": "Chandrapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 424001,
        "State": "MAHARASHTRA",
        "District": "Dhule",
        "City": "Dhule",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 441207,
        "State": "MAHARASHTRA",
        "District": "Gadchiroli",
        "City": "Gadchiroli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 441601,
        "State": "MAHARASHTRA",
        "District": "Gondia",
        "City": "Gondia",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 431501,
        "State": "MAHARASHTRA",
        "District": "Hingoli",
        "City": "Hingoli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 424101,
        "State": "MAHARASHTRA",
        "District": "Jalgaon",
        "City": "Jalgaon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 431114,
        "State": "MAHARASHTRA",
        "District": "Jalna",
        "City": "Jalna",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 415101,
        "State": "MAHARASHTRA",
        "District": "Kolhapur",
        "City": "Kolhapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 413502,
        "State": "MAHARASHTRA",
        "District": "Latur",
        "City": "Latur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 400001,
        "State": "MAHARASHTRA",
        "District": "Mumbai",
        "City": "Mumbai",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 400001,
        "State": "MAHARASHTRA",
        "District": "Mumbai",
        "City": "Ulhasnagar",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 440001,
        "State": "MAHARASHTRA",
        "District": "Nagpur",
        "City": "Nagpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 431601,
        "State": "MAHARASHTRA",
        "District": "Nanded",
        "City": "Nanded",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 425409,
        "State": "MAHARASHTRA",
        "District": "Nandurbar",
        "City": "Nandurbar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 422001,
        "State": "MAHARASHTRA",
        "District": "Nashik",
        "City": "Nashik",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 413405,
        "State": "MAHARASHTRA",
        "District": "Osmanabad",
        "City": "Osmanabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 431401,
        "State": "MAHARASHTRA",
        "District": "Parbhani",
        "City": "Parbhani",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 410301,
        "State": "MAHARASHTRA",
        "District": "Pune",
        "City": "Pune",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 400001,
        "State": "MAHARASHTRA",
        "District": "Raigarh(MH)",
        "City": "Raigarh(MH)",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 415202,
        "State": "MAHARASHTRA",
        "District": "Ratnagiri",
        "City": "Ratnagiri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 415301,
        "State": "MAHARASHTRA",
        "District": "Sangli",
        "City": "Sangli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 412206,
        "State": "MAHARASHTRA",
        "District": "Satara",
        "City": "Satara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 416510,
        "State": "MAHARASHTRA",
        "District": "Sindhudurg",
        "City": "Sindhudurg",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 413001,
        "State": "MAHARASHTRA",
        "District": "Solapur",
        "City": "Solapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 400601,
        "State": "MAHARASHTRA",
        "District": "Thane",
        "City": "Thane",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 442001,
        "State": "MAHARASHTRA",
        "District": "Wardha",
        "City": "Wardha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 444004,
        "State": "MAHARASHTRA",
        "District": "Washim",
        "City": "Washim",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 445001,
        "State": "MAHARASHTRA",
        "District": "Yavatmal",
        "City": "Yavatmal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795118,
        "State": "MANIPUR",
        "District": "Bishnupur",
        "City": "Bishnupur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795101,
        "State": "MANIPUR",
        "District": "Chandel",
        "City": "Chandel",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795006,
        "State": "MANIPUR",
        "District": "Churachandpur",
        "City": "Churachandpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795003,
        "State": "MANIPUR",
        "District": "Imphal East",
        "City": "Imphal East",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795001,
        "State": "MANIPUR",
        "District": "Imphal West",
        "City": "Imphal West",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795007,
        "State": "MANIPUR",
        "District": "Senapati",
        "City": "Senapati",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795125,
        "State": "MANIPUR",
        "District": "Tamenglong",
        "City": "Tamenglong",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795101,
        "State": "MANIPUR",
        "District": "Thoubal",
        "City": "Thoubal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 795142,
        "State": "MANIPUR",
        "District": "Ukhrul",
        "City": "Ukhrul",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 783123,
        "State": "MEGHALAYA",
        "District": "East Garo Hills",
        "City": "East Garo Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 793001,
        "State": "MEGHALAYA",
        "District": "East Khasi Hills",
        "City": "East Khasi Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 793109,
        "State": "MEGHALAYA",
        "District": "Jaintia Hills",
        "City": "Jaintia Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 793101,
        "State": "MEGHALAYA",
        "District": "Ri Bhoi",
        "City": "Ri Bhoi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 794102,
        "State": "MEGHALAYA",
        "District": "South Garo Hills",
        "City": "South Garo Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 794001,
        "State": "MEGHALAYA",
        "District": "West Garo Hills",
        "City": "West Garo Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 793106,
        "State": "MEGHALAYA",
        "District": "West Khasi Hills",
        "City": "West Khasi Hills",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796001,
        "State": "MIZORAM",
        "District": "Aizawl",
        "City": "Aizawl",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796290,
        "State": "MIZORAM",
        "District": "Champhai",
        "City": "Champhai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796070,
        "State": "MIZORAM",
        "District": "Kolasib",
        "City": "Kolasib",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796770,
        "State": "MIZORAM",
        "District": "Lawngtlai",
        "City": "Lawngtlai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796571,
        "State": "MIZORAM",
        "District": "Lunglei",
        "City": "Lunglei",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796410,
        "State": "MIZORAM",
        "District": "Mammit",
        "City": "Mammit",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796901,
        "State": "MIZORAM",
        "District": "Saiha",
        "City": "Saiha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 796181,
        "State": "MIZORAM",
        "District": "Serchhip",
        "City": "Serchhip",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 797103,
        "State": "NAGALAND",
        "District": "Dimapur",
        "City": "Dimapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 798611,
        "State": "NAGALAND",
        "District": "Kiphire",
        "City": "Kiphire",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 797001,
        "State": "NAGALAND",
        "District": "Kohima",
        "City": "Kohima",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 798625,
        "State": "NAGALAND",
        "District": "Longleng",
        "City": "Longleng",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 798601,
        "State": "NAGALAND",
        "District": "Mokokchung",
        "City": "Mokokchung",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 798602,
        "State": "NAGALAND",
        "District": "Mon",
        "City": "Mon",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 797101,
        "State": "NAGALAND",
        "District": "Peren",
        "City": "Peren",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 797102,
        "State": "NAGALAND",
        "District": "Phek",
        "City": "Phek",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 798612,
        "State": "NAGALAND",
        "District": "Tuensang",
        "City": "Tuensang",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 797099,
        "State": "NAGALAND",
        "District": "Wokha",
        "City": "Wokha",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 797109,
        "State": "NAGALAND",
        "District": "Zunhebotto",
        "City": "Zunhebotto",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 160022,
        "State": "NULL",
        "District": "NULL",
        "City": "NULL",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 759037,
        "State": "ODISHA",
        "District": "Angul",
        "City": "Angul",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 767001,
        "State": "ODISHA",
        "District": "Balangir",
        "City": "Balangir",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 756001,
        "State": "ODISHA",
        "District": "Baleswar",
        "City": "Baleswar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 768027,
        "State": "ODISHA",
        "District": "Bargarh",
        "City": "Bargarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 756100,
        "State": "ODISHA",
        "District": "Bhadrak",
        "City": "Bhadrak",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 752120,
        "State": "ODISHA",
        "District": "Bhubaneshwar",
        "City": "Bhubaneshwar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 762012,
        "State": "ODISHA",
        "District": "Boudh",
        "City": "Boudh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 768107,
        "State": "ODISHA",
        "District": "Debagarh",
        "City": "Debagarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 759001,
        "State": "ODISHA",
        "District": "Dhenkanal",
        "City": "Dhenkanal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 761014,
        "State": "ODISHA",
        "District": "Gajapati",
        "City": "Gajapati",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 760001,
        "State": "ODISHA",
        "District": "Ganjam",
        "City": "Ganjam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 754102,
        "State": "ODISHA",
        "District": "Jagatsinghapur",
        "City": "Jagatsinghapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 754023,
        "State": "ODISHA",
        "District": "Jajapur",
        "City": "Jajapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 768201,
        "State": "ODISHA",
        "District": "Jharsuguda",
        "City": "Jharsuguda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 766001,
        "State": "ODISHA",
        "District": "Kalahandi",
        "City": "Kalahandi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 762001,
        "State": "ODISHA",
        "District": "Kandhamal",
        "City": "Kandhamal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 754134,
        "State": "ODISHA",
        "District": "Kendrapara",
        "City": "Kendrapara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 755019,
        "State": "ODISHA",
        "District": "Kendujhar",
        "City": "Kendujhar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 751001,
        "State": "ODISHA",
        "District": "Khorda",
        "City": "Khorda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 763001,
        "State": "ODISHA",
        "District": "Koraput",
        "City": "Koraput",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 764041,
        "State": "ODISHA",
        "District": "Malkangiri",
        "City": "Malkangiri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 757001,
        "State": "ODISHA",
        "District": "Mayurbhanj",
        "City": "Mayurbhanj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 764049,
        "State": "ODISHA",
        "District": "Nabarangapur",
        "City": "Nabarangapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 752024,
        "State": "ODISHA",
        "District": "Nayagarh",
        "City": "Nayagarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 766104,
        "State": "ODISHA",
        "District": "Nuapada",
        "City": "Nuapada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 752001,
        "State": "ODISHA",
        "District": "Puri",
        "City": "Puri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 764059,
        "State": "ODISHA",
        "District": "Rayagada",
        "City": "Rayagada",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 768001,
        "State": "ODISHA",
        "District": "Sambalpur",
        "City": "Sambalpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 767016,
        "State": "ODISHA",
        "District": "Sonapur",
        "City": "Sonapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 769001,
        "State": "ODISHA",
        "District": "Sundergarh",
        "City": "Sundergarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 609601,
        "State": "PONDICHERRY",
        "District": "Karaikal",
        "City": "Karaikal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 673310,
        "State": "PONDICHERRY",
        "District": "Mahe",
        "City": "Mahe",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 533464,
        "State": "PONDICHERRY",
        "District": "Pondicherry",
        "City": "Pondicherry",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 143001,
        "State": "PUNJAB",
        "District": "Amritsar",
        "City": "Amritsar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 148024,
        "State": "PUNJAB",
        "District": "Barnala",
        "City": "Barnala",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 151001,
        "State": "PUNJAB",
        "District": "Bathinda",
        "City": "Bathinda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 151202,
        "State": "PUNJAB",
        "District": "Faridkot",
        "City": "Faridkot",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 140405,
        "State": "PUNJAB",
        "District": "Fatehgarh Sahib",
        "City": "Fatehgarh Sahib",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 152118,
        "State": "PUNJAB",
        "District": "Fazilka",
        "City": "Fazilka",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 142041,
        "State": "PUNJAB",
        "District": "Firozpur",
        "City": "Firozpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 143505,
        "State": "PUNJAB",
        "District": "Gurdaspur",
        "City": "Gurdaspur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 144105,
        "State": "PUNJAB",
        "District": "Hoshiarpur",
        "City": "Hoshiarpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 144001,
        "State": "PUNJAB",
        "District": "Jalandhar",
        "City": "Jalandhar",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 144032,
        "State": "PUNJAB",
        "District": "Kapurthala",
        "City": "Kapurthala",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 141001,
        "State": "PUNJAB",
        "District": "Ludhiana",
        "City": "Ludhiana",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 151501,
        "State": "PUNJAB",
        "District": "Mansa",
        "City": "Mansa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 142001,
        "State": "PUNJAB",
        "District": "Moga",
        "City": "Moga",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 140103,
        "State": "PUNJAB",
        "District": "Mohali",
        "City": "Mohali",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 151202,
        "State": "PUNJAB",
        "District": "Muktsar",
        "City": "Muktsar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 144029,
        "State": "PUNJAB",
        "District": "Nawanshahr",
        "City": "Nawanshahr",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 143533,
        "State": "PUNJAB",
        "District": "Pathankot",
        "City": "Pathankot",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 140201,
        "State": "PUNJAB",
        "District": "Patiala",
        "City": "Patiala",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 140101,
        "State": "PUNJAB",
        "District": "Ropar",
        "City": "Ropar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 140001,
        "State": "PUNJAB",
        "District": "Rupnagar",
        "City": "Rupnagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 148001,
        "State": "PUNJAB",
        "District": "Sangrur",
        "City": "Sangrur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 143009,
        "State": "PUNJAB",
        "District": "Tarn Taran",
        "City": "Tarn Taran",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 305001,
        "State": "RAJASTHAN",
        "District": "Ajmer",
        "City": "Ajmer",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 301001,
        "State": "RAJASTHAN",
        "District": "Alwar",
        "City": "Alwar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 327001,
        "State": "RAJASTHAN",
        "District": "Banswara",
        "City": "Banswara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 325202,
        "State": "RAJASTHAN",
        "District": "Baran",
        "City": "Baran",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 344001,
        "State": "RAJASTHAN",
        "District": "Barmer",
        "City": "Barmer",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 321001,
        "State": "RAJASTHAN",
        "District": "Bharatpur",
        "City": "Bharatpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 311001,
        "State": "RAJASTHAN",
        "District": "Bhilwara",
        "City": "Bhilwara",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 331801,
        "State": "RAJASTHAN",
        "District": "Bikaner",
        "City": "Bikaner",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 323001,
        "State": "RAJASTHAN",
        "District": "Bundi",
        "City": "Bundi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 312001,
        "State": "RAJASTHAN",
        "District": "Chittorgarh",
        "City": "Chittorgarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 331001,
        "State": "RAJASTHAN",
        "District": "Churu",
        "City": "Churu",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 303004,
        "State": "RAJASTHAN",
        "District": "Dausa",
        "City": "Dausa",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 328001,
        "State": "RAJASTHAN",
        "District": "Dholpur",
        "City": "Dholpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 314001,
        "State": "RAJASTHAN",
        "District": "Dungarpur",
        "City": "Dungarpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 335001,
        "State": "RAJASTHAN",
        "District": "Ganganagar",
        "City": "Ganganagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 335024,
        "State": "RAJASTHAN",
        "District": "Hanumangarh",
        "City": "Hanumangarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 302001,
        "State": "RAJASTHAN",
        "District": "Jaipur",
        "City": "Jaipur",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 342302,
        "State": "RAJASTHAN",
        "District": "Jaisalmer",
        "City": "Jaisalmer",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 307029,
        "State": "RAJASTHAN",
        "District": "Jalor",
        "City": "Jalor",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 326001,
        "State": "RAJASTHAN",
        "District": "Jhalawar",
        "City": "Jhalawar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 331025,
        "State": "RAJASTHAN",
        "District": "Jhujhunu",
        "City": "Jhujhunu",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 342001,
        "State": "RAJASTHAN",
        "District": "Jodhpur",
        "City": "Jodhpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 321610,
        "State": "RAJASTHAN",
        "District": "Karauli",
        "City": "Karauli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 324001,
        "State": "RAJASTHAN",
        "District": "Kota",
        "City": "Kota",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 305026,
        "State": "RAJASTHAN",
        "District": "Nagaur",
        "City": "Nagaur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 306001,
        "State": "RAJASTHAN",
        "District": "Pali",
        "City": "Pali",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 305921,
        "State": "RAJASTHAN",
        "District": "Rajsamand",
        "City": "Rajsamand",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 322001,
        "State": "RAJASTHAN",
        "District": "Sawai Madhopur",
        "City": "Sawai Madhopur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 331024,
        "State": "RAJASTHAN",
        "District": "Sikar",
        "City": "Sikar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 307001,
        "State": "RAJASTHAN",
        "District": "Sirohi",
        "City": "Sirohi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 304001,
        "State": "RAJASTHAN",
        "District": "Tonk",
        "City": "Tonk",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 307025,
        "State": "RAJASTHAN",
        "District": "Udaipur",
        "City": "Udaipur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 737101,
        "State": "SIKKIM",
        "District": "East Sikkim",
        "City": "East Sikkim",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 737116,
        "State": "SIKKIM",
        "District": "North Sikkim",
        "City": "North Sikkim",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 737102,
        "State": "SIKKIM",
        "District": "South Sikkim",
        "City": "South Sikkim",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 737111,
        "State": "SIKKIM",
        "District": "West Sikkim",
        "City": "West Sikkim",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 608703,
        "State": "TAMIL NADU",
        "District": "Ariyalur",
        "City": "Ariyalur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 600001,
        "State": "TAMIL NADU",
        "District": "Chennai",
        "City": "Chennai",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 624622,
        "State": "TAMIL NADU",
        "District": "Coimbatore",
        "City": "Coimbatore",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 624622,
        "State": "TAMIL NADU",
        "District": "Coimbatore",
        "City": "Tiruppur",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 605007,
        "State": "TAMIL NADU",
        "District": "Cuddalore",
        "City": "Cuddalore",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 635111,
        "State": "TAMIL NADU",
        "District": "Dharmapuri",
        "City": "Dharmapuri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 624001,
        "State": "TAMIL NADU",
        "District": "Dindigul",
        "City": "Dindigul",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 638001,
        "State": "TAMIL NADU",
        "District": "Erode",
        "City": "Erode",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 600016,
        "State": "TAMIL NADU",
        "District": "Kanchipuram",
        "City": "Kanchipuram",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 629001,
        "State": "TAMIL NADU",
        "District": "Kanyakumari",
        "City": "Kanyakumari",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 621301,
        "State": "TAMIL NADU",
        "District": "Karur",
        "City": "Karur",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 635001,
        "State": "TAMIL NADU",
        "District": "Krishnagiri",
        "City": "Hosur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 635001,
        "State": "TAMIL NADU",
        "District": "Krishnagiri",
        "City": "Krishnagiri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 625001,
        "State": "TAMIL NADU",
        "District": "Madurai",
        "City": "Madurai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 609001,
        "State": "TAMIL NADU",
        "District": "Nagapattinam",
        "City": "Nagapattinam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 621215,
        "State": "TAMIL NADU",
        "District": "Namakkal",
        "City": "Namakkal",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 643001,
        "State": "TAMIL NADU",
        "District": "Nilgiris",
        "City": "Nilgiris",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 621101,
        "State": "TAMIL NADU",
        "District": "Perambalur",
        "City": "Perambalur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 613301,
        "State": "TAMIL NADU",
        "District": "Pudukkottai",
        "City": "Pudukkottai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 623115,
        "State": "TAMIL NADU",
        "District": "Ramanathapuram",
        "City": "Ramanathapuram",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 621110,
        "State": "TAMIL NADU",
        "District": "Salem",
        "City": "Salem",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 621308,
        "State": "TAMIL NADU",
        "District": "Sivaganga",
        "City": "Sivaganga",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 609802,
        "State": "TAMIL NADU",
        "District": "Thanjavur",
        "City": "Thanjavur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 625203,
        "State": "TAMIL NADU",
        "District": "Theni",
        "City": "Theni",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 607201,
        "State": "TAMIL NADU",
        "District": "Tiruchirappalli",
        "City": "Tiruchirappalli",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 607201,
        "State": "TAMIL NADU",
        "District": "Tiruchirappalli",
        "City": "Trichy",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 627001,
        "State": "TAMIL NADU",
        "District": "Tirunelveli",
        "City": "Tirunelveli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 600019,
        "State": "TAMIL NADU",
        "District": "Tiruvallur",
        "City": "Tiruvallur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 604401,
        "State": "TAMIL NADU",
        "District": "Tiruvannamalai",
        "City": "Tiruvannamalai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 609403,
        "State": "TAMIL NADU",
        "District": "Tiruvarur",
        "City": "Tiruvarur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 626202,
        "State": "TAMIL NADU",
        "District": "Tuticorin",
        "City": "Tuticorin",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 604407,
        "State": "TAMIL NADU",
        "District": "Vellore",
        "City": "Vellore",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 604001,
        "State": "TAMIL NADU",
        "District": "Villupuram",
        "City": "Villupuram",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 626001,
        "State": "TAMIL NADU",
        "District": "Virudhunagar",
        "City": "Virudhunagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 504001,
        "State": "TELANGANA",
        "District": "Adilabad",
        "City": "Adilabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 500001,
        "State": "TELANGANA",
        "District": "Hyderabad",
        "City": "Hyderabad",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 500001,
        "State": "TELANGANA",
        "District": "Hyderabad",
        "City": "Sangareddy",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 500001,
        "State": "TELANGANA",
        "District": "Hyderabad",
        "City": "Toopran",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 500005,
        "State": "TELANGANA",
        "District": "K.V.Rangareddy",
        "City": "K.V.Rangareddy",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 505001,
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Karim Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 505001,
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Ramagundam",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 507001,
        "State": "TELANGANA",
        "District": "Khammam",
        "City": "Khammam",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 509001,
        "State": "TELANGANA",
        "District": "Mahabub Nagar",
        "City": "Mahabub Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 502001,
        "State": "TELANGANA",
        "District": "Medak",
        "City": "Medak",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 508001,
        "State": "TELANGANA",
        "District": "Nalgonda",
        "City": "Kodad",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 508001,
        "State": "TELANGANA",
        "District": "Nalgonda",
        "City": "Nalgonda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 503001,
        "State": "TELANGANA",
        "District": "Nizamabad",
        "City": "Nizamabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 506001,
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Warangal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 799204,
        "State": "TRIPURA",
        "District": "Dhalai",
        "City": "Dhalai",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 799250,
        "State": "TRIPURA",
        "District": "North Tripura",
        "City": "North Tripura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 799013,
        "State": "TRIPURA",
        "District": "South Tripura",
        "City": "South Tripura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 799001,
        "State": "TRIPURA",
        "District": "West Tripura",
        "City": "West Tripura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 202124,
        "State": "UTTAR PRADESH",
        "District": "Agra",
        "City": "Agra",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 202001,
        "State": "UTTAR PRADESH",
        "District": "Aligarh",
        "City": "Aligarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 211001,
        "State": "UTTAR PRADESH",
        "District": "Allahabad",
        "City": "Allahabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 224121,
        "State": "UTTAR PRADESH",
        "District": "Ambedkar Nagar",
        "City": "Ambedkar Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 206121,
        "State": "UTTAR PRADESH",
        "District": "Auraiya",
        "City": "Auraiya",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 221602,
        "State": "UTTAR PRADESH",
        "District": "Azamgarh",
        "City": "Azamgarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 250101,
        "State": "UTTAR PRADESH",
        "District": "Bagpat",
        "City": "Bagpat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 271801,
        "State": "UTTAR PRADESH",
        "District": "Bahraich",
        "City": "Bahraich",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 221701,
        "State": "UTTAR PRADESH",
        "District": "Ballia",
        "City": "Ballia",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 271201,
        "State": "UTTAR PRADESH",
        "District": "Balrampur",
        "City": "Balrampur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 210001,
        "State": "UTTAR PRADESH",
        "District": "Banda",
        "City": "Banda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 224116,
        "State": "UTTAR PRADESH",
        "District": "Barabanki",
        "City": "Barabanki",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 243001,
        "State": "UTTAR PRADESH",
        "District": "Bareilly",
        "City": "Bareilly",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 271305,
        "State": "UTTAR PRADESH",
        "District": "Basti",
        "City": "Basti",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 246701,
        "State": "UTTAR PRADESH",
        "District": "Bijnor",
        "City": "Bijnor",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 242021,
        "State": "UTTAR PRADESH",
        "District": "Budaun",
        "City": "Budaun",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 203001,
        "State": "UTTAR PRADESH",
        "District": "Bulandshahr",
        "City": "Bulandshahr",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 221009,
        "State": "UTTAR PRADESH",
        "District": "Chandauli",
        "City": "Chandauli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 210202,
        "State": "UTTAR PRADESH",
        "District": "Chitrakoot",
        "City": "Chitrakoot",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 274001,
        "State": "UTTAR PRADESH",
        "District": "Deoria",
        "City": "Deoria",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 207001,
        "State": "UTTAR PRADESH",
        "District": "Etah",
        "City": "Etah",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 206001,
        "State": "UTTAR PRADESH",
        "District": "Etawah",
        "City": "Etawah",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 224001,
        "State": "UTTAR PRADESH",
        "District": "Faizabad",
        "City": "Faizabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 209501,
        "State": "UTTAR PRADESH",
        "District": "Farrukhabad",
        "City": "Farrukhabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 212601,
        "State": "UTTAR PRADESH",
        "District": "Fatehpur",
        "City": "Fatehpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 205262,
        "State": "UTTAR PRADESH",
        "District": "Firozabad",
        "City": "Firozabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 201008,
        "State": "UTTAR PRADESH",
        "District": "Gautam Buddha Nagar",
        "City": "Gautam Buddha Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 201001,
        "State": "UTTAR PRADESH",
        "District": "Ghaziabad",
        "City": "Ghaziabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 232325,
        "State": "UTTAR PRADESH",
        "District": "Ghazipur",
        "City": "Ghazipur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 271001,
        "State": "UTTAR PRADESH",
        "District": "Gonda",
        "City": "Gonda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 273001,
        "State": "UTTAR PRADESH",
        "District": "Gorakhpur",
        "City": "Gorakhpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 201301,
        "State": "UTTAR PRADESH",
        "District": "Greater Noida",
        "City": "Greater Noida",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 210301,
        "State": "UTTAR PRADESH",
        "District": "Hamirpur",
        "City": "Hamirpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 241001,
        "State": "UTTAR PRADESH",
        "District": "Hardoi",
        "City": "Hardoi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 202002,
        "State": "UTTAR PRADESH",
        "District": "Hathras",
        "City": "Hathras",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 284203,
        "State": "UTTAR PRADESH",
        "District": "Jalaun",
        "City": "Jalaun",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 222001,
        "State": "UTTAR PRADESH",
        "District": "Jaunpur",
        "City": "Jaunpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 284001,
        "State": "UTTAR PRADESH",
        "District": "Jhansi",
        "City": "Jhansi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 244102,
        "State": "UTTAR PRADESH",
        "District": "Jyotiba Phule Nagar",
        "City": "Jyotiba Phule Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 209720,
        "State": "UTTAR PRADESH",
        "District": "Kannauj",
        "City": "Kannauj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 208001,
        "State": "UTTAR PRADESH",
        "District": "Kanpur",
        "City": "Kanpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 208001,
        "State": "UTTAR PRADESH",
        "District": "Kanpur Dehat",
        "City": "Kanpur Dehat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 211011,
        "State": "UTTAR PRADESH",
        "District": "Kaushambi",
        "City": "Kaushambi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 261501,
        "State": "UTTAR PRADESH",
        "District": "Kheri",
        "City": "Kheri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 274149,
        "State": "UTTAR PRADESH",
        "District": "Kushinagar",
        "City": "Kushinagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 284122,
        "State": "UTTAR PRADESH",
        "District": "Lalitpur",
        "City": "Lalitpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 226001,
        "State": "UTTAR PRADESH",
        "District": "Lucknow",
        "City": "Lucknow",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 273151,
        "State": "UTTAR PRADESH",
        "District": "Maharajganj",
        "City": "Maharajganj",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 210421,
        "State": "UTTAR PRADESH",
        "District": "Mahoba",
        "City": "Mahoba",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 205001,
        "State": "UTTAR PRADESH",
        "District": "Mainpuri",
        "City": "Mainpuri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 281001,
        "State": "UTTAR PRADESH",
        "District": "Mathura",
        "City": "Mathura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 221601,
        "State": "UTTAR PRADESH",
        "District": "Mau",
        "City": "Mau",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 245206,
        "State": "UTTAR PRADESH",
        "District": "Meerut",
        "City": "Meerut",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 231001,
        "State": "UTTAR PRADESH",
        "District": "Mirzapur",
        "City": "Mirzapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 244001,
        "State": "UTTAR PRADESH",
        "District": "Moradabad",
        "City": "Moradabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 247771,
        "State": "UTTAR PRADESH",
        "District": "Muzaffarnagar",
        "City": "Muzaffarnagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 243003,
        "State": "UTTAR PRADESH",
        "District": "Pilibhit",
        "City": "Pilibhit",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 222301,
        "State": "UTTAR PRADESH",
        "District": "Pratapgarh",
        "City": "Pratapgarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 229001,
        "State": "UTTAR PRADESH",
        "District": "Raebareli",
        "City": "Raebareli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 244701,
        "State": "UTTAR PRADESH",
        "District": "Rampur",
        "City": "Rampur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 247001,
        "State": "UTTAR PRADESH",
        "District": "Saharanpur",
        "City": "Saharanpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 272125,
        "State": "UTTAR PRADESH",
        "District": "Sant Kabir Nagar",
        "City": "Sant Kabir Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 221301,
        "State": "UTTAR PRADESH",
        "District": "Sant Ravidas Nagar",
        "City": "Sant Ravidas Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 242001,
        "State": "UTTAR PRADESH",
        "District": "Shahjahanpur",
        "City": "Shahjahanpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 271201,
        "State": "UTTAR PRADESH",
        "District": "Shrawasti",
        "City": "Shrawasti",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 272129,
        "State": "UTTAR PRADESH",
        "District": "Siddharthnagar",
        "City": "Siddharthnagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 261001,
        "State": "UTTAR PRADESH",
        "District": "Sitapur",
        "City": "Sitapur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 231205,
        "State": "UTTAR PRADESH",
        "District": "Sonbhadra",
        "City": "Sonbhadra",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 222301,
        "State": "UTTAR PRADESH",
        "District": "Sultanpur",
        "City": "Sultanpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 209101,
        "State": "UTTAR PRADESH",
        "District": "Unnao",
        "City": "Unnao",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 221001,
        "State": "UTTAR PRADESH",
        "District": "Varanasi",
        "City": "Varanasi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 244715,
        "State": "UTTARAKHAND",
        "District": "Almora",
        "City": "Almora",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 263619,
        "State": "UTTARAKHAND",
        "District": "Bageshwar",
        "City": "Bageshwar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 246401,
        "State": "UTTARAKHAND",
        "District": "Chamoli",
        "City": "Chamoli",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 262308,
        "State": "UTTARAKHAND",
        "District": "Champawat",
        "City": "Champawat",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 247670,
        "State": "UTTARAKHAND",
        "District": "Dehradun",
        "City": "Dehradun",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 246763,
        "State": "UTTARAKHAND",
        "District": "Haridwar",
        "City": "Haridwar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 244713,
        "State": "UTTARAKHAND",
        "District": "Nainital",
        "City": "Nainital",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 246001,
        "State": "UTTARAKHAND",
        "District": "Pauri Garhwal",
        "City": "Pauri Garhwal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 262501,
        "State": "UTTARAKHAND",
        "District": "Pithoragarh",
        "City": "Pithoragarh",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 246141,
        "State": "UTTARAKHAND",
        "District": "Rudraprayag",
        "City": "Rudraprayag",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 249001,
        "State": "UTTARAKHAND",
        "District": "Tehri Garhwal",
        "City": "Tehri Garhwal",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 244712,
        "State": "UTTARAKHAND",
        "District": "Udham Singh Nagar",
        "City": "Udham Singh Nagar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 249128,
        "State": "UTTARAKHAND",
        "District": "Uttarkashi",
        "City": "Uttarkashi",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 713150,
        "State": "WEST BENGAL",
        "District": "Bankura",
        "City": "Bankura",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 712410,
        "State": "WEST BENGAL",
        "District": "Bardhaman",
        "City": "Bardhaman",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 731101,
        "State": "WEST BENGAL",
        "District": "Birbhum",
        "City": "Birbhum",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 735122,
        "State": "WEST BENGAL",
        "District": "Cooch Behar",
        "City": "Cooch Behar",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 734001,
        "State": "WEST BENGAL",
        "District": "Darjiling",
        "City": "Darjiling",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 721130,
        "State": "WEST BENGAL",
        "District": "East Midnapore",
        "City": "East Midnapore",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 712101,
        "State": "WEST BENGAL",
        "District": "Hooghly",
        "City": "Hooghly",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 711101,
        "State": "WEST BENGAL",
        "District": "Howrah",
        "City": "Howrah",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 734001,
        "State": "WEST BENGAL",
        "District": "Jalpaiguri",
        "City": "Jalpaiguri",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 700001,
        "State": "WEST BENGAL",
        "District": "Kolkata",
        "City": "Kolkata",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 700001,
        "State": "WEST BENGAL",
        "District": "Kolkata",
        "City": "Serampore",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 732101,
        "State": "WEST BENGAL",
        "District": "Malda",
        "City": "Malda",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 721101,
        "State": "WEST BENGAL",
        "District": "Medinipur",
        "City": "Medinipur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 713123,
        "State": "WEST BENGAL",
        "District": "Murshidabad",
        "City": "Murshidabad",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 741101,
        "State": "WEST BENGAL",
        "District": "Nadia",
        "City": "Nadia",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 700048,
        "State": "WEST BENGAL",
        "District": "North 24 Parganas",
        "City": "North 24 Parganas",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 733121,
        "State": "WEST BENGAL",
        "District": "North Dinajpur",
        "City": "North Dinajpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 723101,
        "State": "WEST BENGAL",
        "District": "Puruliya",
        "City": "Puruliya",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 700039,
        "State": "WEST BENGAL",
        "District": "South 24 Parganas",
        "City": "South 24 Parganas",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 733101,
        "State": "WEST BENGAL",
        "District": "South Dinajpur",
        "City": "South Dinajpur",
        "ModeofExam": "Online"
    },
    {
        "Pincode": 721101,
        "State": "WEST BENGAL",
        "District": "West Midnapore",
        "City": "West Midnapore",
        "ModeofExam": "Online"
    },
    {
        "State": "TELANGANA",
        "District": "Adilabad",
        "City": "Adilabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Bhadradri Kothagudem",
        "City": "Bhadrachalam",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Bhadradri Kothagudem",
        "City": "Kothagudem",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Bhadradri Kothagudem",
        "City": "Manugur",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Bhadradri Kothagudem",
        "City": "Palvancha",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Hanamkonda",
        "City": "Hanamkonda",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Hanamkonda",
        "City": "Hanmakonda",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Hanamkonda",
        "City": "Kazipet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Hyderabad",
        "City": "Hyderabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Hyderabad",
        "City": "Sangareddy",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Hyderabad",
        "City": "Toopran",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Janagoan",
        "City": "Janagoan",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Jayashankar Bhupalpally&nbsp;",
        "City": "Bhupalpally",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Jogulamba-Gadwal",
        "City": "Gadwal",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Kamareddy",
        "City": "Kamareddy",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Boiwada",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Huzurabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Jagtial",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Karim Nagar",
        "ModeofExam": "Online"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Korutla",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Thimmapur",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Ramagundam",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Karim Nagar",
        "City": "Vavilalapally",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Khammam",
        "City": "Khammam",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Khammam",
        "City": "Madhira",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Khammam",
        "City": "Sathupally",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Komaram Bheem",
        "City": "Sirpur Kagaz Nagar",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Mahabubabad",
        "City": "Thorrur",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Mahabub Nagar",
        "City": "Jadcherla",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Mahabub Nagar",
        "City": "Mahabub Nagar",
        "ModeofExam": "Online"
    },
    {
        "State": "TELANGANA",
        "District": "Mancheriyal",
        "City": "Bellampally",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Mancheriyal",
        "City": "Mancheriyal",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Mancheriyal",
        "City": "Mandamarri",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Medak",
        "City": "Medak",
        "ModeofExam": "Online"
    },
    {
        "State": "TELANGANA",
        "District": "Medak",
        "City": "Sadasivpet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Medchal",
        "City": "Dammaiguda",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Medchal-Malkajgiri",
        "City": "Hyderabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nagarkurnool",
        "City": "Achampet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nagarkurnool",
        "City": "Kalwakurthy",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nagarkurnool",
        "City": "Nagarkurnool",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nalgonda",
        "City": "Miryalaguda",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nalgonda",
        "City": "Nakirekal",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nalgonda",
        "City": "Kodad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nalgonda",
        "City": "Nalgonda",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nirmal",
        "City": "Nirmal",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nizamabad",
        "City": "Armoor",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Nizamabad",
        "City": "Nizamabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Peddapalli",
        "City": "Godavarikhani",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Peddapalli",
        "City": "Sultanabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Rajanna Sircilla ",
        "City": "Sircilla",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Rajanna Sircilla ",
        "City": "Vemulawada",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Rajanna Sircilla ",
        "City": "Yellareddypet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "K.V.Rangareddy",
        "City": "K.V.Rangareddy",
        "ModeofExam": "Online"
    },
    {
        "State": "TELANGANA",
        "District": "K.V.Rangareddy",
        "City": "Kandukur",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "K.V.Rangareddy",
        "City": "Moinabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "K.V.Rangareddy",
        "City": "Shadnagar",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "K.V.Rangareddy",
        "City": "Tukkuguda",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Sangareddy",
        "City": "Sangareddy",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Sangareddy",
        "City": "Zaheerabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Siddipet",
        "City": "Husnabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Siddipet",
        "City": "Siddipet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Siddipet",
        "City": "Siddipet ",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Suryapet",
        "City": "Huzurnagar",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Suryapet",
        "City": "Suryapet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Vikarabad",
        "City": "Tandur",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Vikarabad",
        "City": "Vikarabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Wanaparthy",
        "City": "Wanaparthy",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Kashibugga",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Mahabubabad",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Narsampet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Rangasaipet",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Warangal",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Warangal",
        "City": "Yellapur",
        "ModeofExam": "Both"
    },
    {
        "State": "TELANGANA",
        "District": "Yadadri Bhuvanagiri ",
        "City": "Bhongir",
        "ModeofExam": "Both"
    },
    {
        "Pincode": 400001,
        "State": "Maharashtra",
        "District": "Mumbai",
        "City": "Navi Mumbai",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 400601,
        "State": "Maharashtra",
        "District": "Mumbai",
        "City": "Thane",
        "ModeofExam": "Offline"
    },
    {
        "Pincode": 590001,
        "State": "Karnataka",
        "District": "Bengaluru",
        "City": "Belagavi",
        "ModeofExam": "Offline"
    }
]